module.exports = __webpack_public_path__ + "static/media/select-icon.2ac8e029.svg";